// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var eq3 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Money_Rounded.eqMoney));
var averageTimeIsSymbol = {
    reflectSymbol: function () {
        return "averageTime";
    }
};
var deliveryCostIsSymbol = {
    reflectSymbol: function () {
        return "deliveryCost";
    }
};
var distanceIsSymbol = {
    reflectSymbol: function () {
        return "distance";
    }
};
var freeDeliveryThresholdIsSymbol = {
    reflectSymbol: function () {
        return "freeDeliveryThreshold";
    }
};
var minOrderValueIsSymbol = {
    reflectSymbol: function () {
        return "minOrderValue";
    }
};
var zoneNameIsSymbol = {
    reflectSymbol: function () {
        return "zoneName";
    }
};
var DeliveryInfoIsSymbol = {
    reflectSymbol: function () {
        return "DeliveryInfo";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney);
var DeliveryInfo = function (x) {
    return x;
};
var toFillFormTypeDeliveryInf = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeDeliveryInfo_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldDeliveryInfo = function (dictHasField) {
    return dictHasField;
};
var eqDeliveryInfo = {
    eq: function (x) {
        return function (y) {
            return eq(x.averageTime)(y.averageTime) && eq1(x.deliveryCost)(y.deliveryCost) && x.distance === y.distance && eq3(x.freeDeliveryThreshold)(y.freeDeliveryThreshold) && eq1(x.minOrderValue)(y.minOrderValue) && x.zoneName === y.zoneName;
        };
    }
};
var genericDeliveryInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDeliveryInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDeliveryInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(averageTimeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(deliveryCostIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(distanceIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(freeDeliveryThresholdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(minOrderValueIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(zoneNameIsSymbol)(Data_Show.showString))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Money_Rounded.showMoney)))(Data_Show.showNumber))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt)))))(DeliveryInfoIsSymbol))
};
var unscrambleDecodeDeliveryInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericDeliveryInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(averageTimeIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1))(/* #__PURE__ */ Unscramble.decodeRecordCons(deliveryCostIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(distanceIsSymbol)(Unscramble.decodeNumber1)(/* #__PURE__ */ Unscramble.decodeRecordCons(freeDeliveryThresholdIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Data_Money_Rounded.udecodeMoney))(/* #__PURE__ */ Unscramble.decodeRecordCons(minOrderValueIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(zoneNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeDeliveryInfo = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericDeliveryInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(DeliveryInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(zoneNameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(minOrderValueIsSymbol)(encodeWithOptionsOther))(freeDeliveryThresholdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_Money_Rounded.encodeMoney))))(distanceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))(deliveryCostIsSymbol)(encodeWithOptionsOther))(averageTimeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.intEncode)))))))
};
var decodeDeliveryInfo = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericDeliveryInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(DeliveryInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(zoneNameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())(minOrderValueIsSymbol)(decodeWithOptionsOther)())(freeDeliveryThresholdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_Money_Rounded.decodeMoney)))())(distanceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode))())(deliveryCostIsSymbol)(decodeWithOptionsOther)())(averageTimeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.intDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    DeliveryInfo,
    genericDeliveryInfo,
    eqDeliveryInfo,
    showDeliveryInfo,
    encodeDeliveryInfo,
    decodeDeliveryInfo,
    unscrambleDecodeDeliveryInfo,
    toFillFormTypeDeliveryInf,
    hasFieldDeliveryInfo,
    newtypeDeliveryInfo_
};
